import { render, staticRenderFns } from "./addHire.vue?vue&type=template&id=5e889d1c&scoped=true&"
import script from "./addHire.vue?vue&type=script&lang=js&"
export * from "./addHire.vue?vue&type=script&lang=js&"
import style0 from "./addHire.vue?vue&type=style&index=0&id=5e889d1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e889d1c",
  null
  
)

export default component.exports